import {useQueryClient} from '@tanstack/react-query';
import {
	BeneficiarySituationEnum,
	GetBeneficiaryModel,
} from 'domain/usecases/others/selection-flow/beneficiary-v3';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {UserTypeEnum} from 'presentation/constants';
import {useAccountInformation} from 'presentation/pages/private/hooks/useAccountInformation';
import {useMemo} from 'react';
import {ActiveDependentItem} from './types';

export function useActiveDependents() {
	const {beneficiary, planBeneficiaries, isHolder} = useAccountInformation();
	const queryClient = useQueryClient();

	const activeDependents = useMemo(() => {
		const cachedData = queryClient.getQueryData<GetBeneficiaryModel>([
			QUERY_KEYS.BENEFICIARIES,
			{nuContrato: beneficiary.nuContrato},
			{excludeWalletCode: true},
		]);

		const source = cachedData?.beneficiarios ?? planBeneficiaries ?? [];

		return source
			.filter(
				b =>
					b.tipoUsuarioC === UserTypeEnum.DEPENDENT &&
					b.situacao === BeneficiarySituationEnum.ACTIVE,
			)
			.map<ActiveDependentItem>(b => ({
				cdPessoaC: b.cdPessoaC,
				nmUsuarioC: b.nmUsuarioC,
				idadeC: b.idadeC,
			}));
	}, [beneficiary.nuContrato, planBeneficiaries, queryClient]);

	const hasActiveDependents = activeDependents.length > 0;

	return {activeDependents, hasActiveDependents, isHolder};
}
